import { DIC } from "@/const/dic";
// import {
//     validateChinese
// } from '@/util/validate'
// import {
//     formatterTime
// } from '@/util/util'
const pass = (rule, value, callback) => {
  if (value) {
    callback();
  } else {
    callback();
  }
};

export const workOrderOption = {
  align: "center",
  menuAlign: "center",
  headerAlign: "center",
  border: true,
  expand: false,
  stripe: false,
  showHeader: true,
  index: false,
  selection: true,
  menu: true,
  menuType:"menu",
  page: true,
  addBtn: false,
  editBtn: false,
  delBtn: false,
  viewBtn: false,
  menuWidth: "120",
  labelWidth: "100",
  defaultSort: {
    prop: "createTime",
    order: "descending",
  },
  column: [
    // 预约卡号
    {
      label: "预约卡号",
      prop: "reservationNum",
      width: "100",
      type: "input",
      search: true,
      editVisdiplay: true,
      overHidden: true,
      formsolt: true,
    },
    {
      label: "工单编号",
      prop: "workOrderNum",
      type: "input",
      width: "100",
      search: false,
      addVisdiplay: false,
      editVisdiplay: false,
      hide: true,
      overHidden: true,
      rules: [
        {
          required: true,
          trigger: "change",
          validator: pass,
        },
      ],
    },
    {
      label: "联系人",
      prop: "reservationName",
      type: "input",
      width: "80",
      overHidden: true,
      rules: [
        {
          required: true,
          trigger: "blur",
          validator: pass,
        },
      ],
    },
    {
      label: "联系电话",
      prop: "reservationMobile",
      search: true,
      type: "input",
      width: "100",
      overHidden: true,
      rules: [
        {
          required: true,
          trigger: "blur",
          validator: pass,
        },
      ],
    },
    // 联系人类型
    {
      label: "联系人类型",
      prop: "appointmentType",
      type: "select",
      width: "80",
      hide: true,
      overHidden: true,
      dicData: DIC.WORK_ORDER_TYPE,
      rules: [
        {
          required: true,
          trigger: "change",
          validator: pass,
        },
      ],
    },
    // 业主姓名
    {
      label: "业主姓名",
      prop: "ownerName",
      type: "input",
      width: "100",
      overHidden: true,
      formsolt: true,
    },
    // 业主电话
    {
      label: "业主电话",
      prop: "ownerMobile",
      type: "input",
      width: "100",
      search: true,
      overHidden: true,
      formsolt: true,
    },
    {
      label: "工程师",
      prop: "workUserId",
      width: "80",
      type: "input",
      solt: true,
      overHidden: true,
      formsolt: true,
      editVisdiplay: true,
      rules: [
        {
          required: true,
          trigger: "change",
          validator: pass,
        },
      ],
    },
    {
      label: "省",
      prop: "province",
      hide: true,
      formsolt: true,
    },
    {
      label: "市",
      prop: "city",
      hide: true,
      formsolt: true,
    },
    {
      label: "区",
      prop: "area",
      hide: true,
      formsolt: true,
    },
    {
      label: "标记位置",
      prop: "provinces",
      hide: true,
      formsolt: true,
      rules: [
        {
          required: true,
          trigger: "change",
          validator: pass,
        },
      ],
    },
    {
      label: "详细地址",
      prop: "address",
      overHidden: true,
      type: "input",
      width: "380",
      solt: true,
      formsolt: true,
      search: true,
      rules: [
        {
          required: true,
          trigger: "blur",
          validator: pass,
        },
      ],
    },
    // {
    //   label: "详细地址",
    //   prop: "address1",
    //   solt: true,
    //   overHidden: true,
    //   search: true,
    //   addVisdiplay: false,
    //   editVisdiplay: false,
    // },
    {
      label: "服务类目",
      prop: "serviceCategory",
      type: "select",
      solt: true,
      overHidden: true,
      clearable: true,
      formsolt: true,
      hide: true,
      editVisdiplay: false,
      rules: [
        {
          required: true,
          trigger: "change",
          validator: pass,
        },
      ],
    },
    {
      label: "服务项目",
      prop: "serviceItems",
      type: "select",
      clearable: true,
      overHidden: true,
      solt: true,
      formsolt: true,
      editVisdiplay: false,
      rules: [
        {
          required: true,
          trigger: "change",
          validator: pass,
        },
      ],
    },
    {
      label: "服务时间",
      prop: "reservationTime",
      type: "datetime",
      sortable: true,
      valueFormat: "timestamp",
      format: "yyyy-MM-dd HH:mm:ss",
      /* rules: [
        {
          required: true,
          trigger: "change",
          validator: pass,
        },
      ], */
    },
        //创建时间
        {
          label: "创建时间",
          prop: "createTime",
          type: "datetime",
          valueFormat: "timestamp",
          format: "yyyy-MM-dd HH:mm:ss",
          addVisdiplay: false,
          editVisdiplay: false,
        },
    {
      label: "工单状态",
      prop: "status",
      solt: true,
      search: true,
      overHidden: true,
      type: "select",
      width: "100",
      dicData: DIC.WORK_ORDER_STATUS,
      addVisdiplay: false,
      editVisdiplay: false,
    },
    {
      label: "支付时间",
      prop: "payTime",
      type: "datetime",
      hide: true,
      overHidden: true,
      sortable: true,
      valueFormat: "timestamp",
      format: "yyyy-MM-dd HH:mm:ss",
      addVisdiplay: false,
      editVisdiplay: false,
    },
    {
      label: "服务时间",
      prop: "startDate_endDate",
      type: "datetimerange",
      sortable: true,
      hide: true,
      valueFormat: "timestamp",
      format: "yyyy-MM-dd HH:mm:ss",
      search: true,
      addVisdiplay: false,
      editVisdiplay: false,
    },
    {
      label: "备注",
      prop: "remarks",
      type: "textarea",
      hide: true,
      span: 24,
      max: 255,
    },
    {
      label: "工程师姓名",
      prop: "workUserName",
      type: "input",
      search: true,
      hide: true,
      addVisdiplay: false,
      editVisdiplay: false,
    },
  ],
};
